/*
 * Router bridge for out-of-component navigation (axios interceptor, thunks,
 * RTK-Query lifecycles). The data router is created at module scope and
 * registered here once. This module imports nothing, so consumers can navigate
 * without pulling in the component tree — which keeps the app free of the
 * http ↔ router ↔ App import cycle.
 *
 * Rule: inside a React component, use `useNavigate` — NOT this bridge. This is
 * only for code that runs outside React and cannot use hooks.
 */

let _router = null;

export const setRouter = (router) => {
    _router = router;
};

export const navigate = (to, options) => {
    if (!_router) {
        // router.jsx registers synchronously at module load, before React
        // renders — a null here signals an import-order regression, not a
        // normal state. Surface it in dev; no-op safely in production.
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(
                '[app/navigation] navigate() called before the router was registered:',
                to
            );
        }
        return undefined;
    }
    return _router.navigate(to, options);
};

export const getPathname = () => _router?.state?.location?.pathname;
